export function createBlob(data, excelType) {
    let buf = new ArrayBuffer(data.length);
    let view = new Uint8Array(buf);
    for (let i = 0; i !== data.length; ++i) {
        view[i] = data.charCodeAt(i) & 0xff;
    }
    let blob = new Blob([buf], {
        type: excelType,
    });
    return blob;
}

export function fetchFile(data, excelType, fileName) {
    let blob = createBlob(data, excelType);
    createLinkForDownload(blob, fileName);
}

export function createLinkForDownload(blob, fileName) {
    // for IE
    if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(blob, fileName);
    }
    // for Non-IE (chrome, firefox etc.)
    else {
        let link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = fileName;
        link.click();
    }
}

export function openDownloadDialog(url, saveName) {
    return createLinkForDownload(url, saveName);
    /*
    if (typeof url == "object" && url instanceof Blob) {
        url = URL.createObjectURL(url); // 创建blob地址
    }
    var aLink = document.createElement("a");
    aLink.href = url;
    aLink.download = saveName || ""; // HTML5新增的属性，指定保存文件名，可以不要后缀，注意，file:///模式下不会生效
    var event;
    if (window.MouseEvent) {
        event = new MouseEvent("click");
    } else {
        event = document.createEvent("MouseEvents");
        event.initMouseEvent(
            "click",
            true,
            false,
            window,
            0,
            0,
            0,
            0,
            0,
            false,
            false,
            false,
            false,
            0,
            null
        );
    }
    aLink.dispatchEvent(event);*/
}

export function sheet2blob(XLSX, sheet, sheetName) {
    sheetName = sheetName || "sheet1";
    var workbook = {
        SheetNames: [sheetName],
        Sheets: {},
    };
    workbook.Sheets[sheetName] = sheet;
    // 生成excel的配置项
    var wopts = {
        bookType: "xlsx", // 要生成的文件类型
        bookSST: false, // 是否生成Shared String Table，官方解释是，如果开启生成速度会下降，但在低版本IOS设备上有更好的兼容性
        type: "binary",
    };
    var wbout = XLSX.write(workbook, wopts);
    var blob =createBlob(wbout,"xlsx");
    // var blob = new Blob([s2ab(wbout)], {
    //     type: "application/octet-stream",
    // });
    // // 字符串转ArrayBuffer
    // function s2ab(s) {
    //     var buf = new ArrayBuffer(s.length);
    //     var view = new Uint8Array(buf);
    //     for (var i = 0; i != s.length; ++i) view[i] = s.charCodeAt(i) & 0xff;
    //     return buf;
    // }
    return blob;
}

export function sheet2blob4Rank(XLSX, sheet1, sheetName1, sheet2, sheetName2) {
    sheetName1 = sheetName1 || "sheet1";
    sheetName2 = sheetName2 || "sheet2";
    var workbook = {
        SheetNames: [sheetName1, sheetName2],
        Sheets: {},
    };
    workbook.Sheets[sheetName1] = sheet1;
    workbook.Sheets[sheetName2] = sheet2;
    // 生成excel的配置项
    var wopts = {
        bookType: "xlsx", // 要生成的文件类型
        bookSST: false, // 是否生成Shared String Table，官方解释是，如果开启生成速度会下降，但在低版本IOS设备上有更好的兼容性
        type: "binary",
    };
    var wbout = XLSX.write(workbook, wopts);
    var blob =createBlob(wbout,"xlsx");
    // var blob = new Blob([s2ab(wbout)], {
    //     type: "application/octet-stream",
    // });
    // 字符串转ArrayBuffer
    // function s2ab(s) {
    //     var buf = new ArrayBuffer(s.length);
    //     var view = new Uint8Array(buf);
    //     for (var i = 0; i != s.length; ++i) view[i] = s.charCodeAt(i) & 0xff;
    //     return buf;
    // }
    return blob;
}

export function sheet2blob4RankMRF(XLSX, sheet1, sheetName1, sheet2, sheetName2 , sheet3, sheetName3) {
    sheetName1 = sheetName1 || "sheet1";
    sheetName2 = sheetName2 || "sheet2";
    sheetName3 = sheetName3 || "sheet3";
    var workbook = {
        SheetNames: [sheetName1, sheetName2 ,sheetName3],
        Sheets: {},
    };
    workbook.Sheets[sheetName1] = sheet1;
    workbook.Sheets[sheetName2] = sheet2;
    workbook.Sheets[sheetName3] = sheet3;
    // 生成excel的配置项
    var wopts = {
        bookType: "xlsx",
        bookSST: false, 
        type: "binary",
    };
    var wbout = XLSX.write(workbook, wopts);
    var blob =createBlob(wbout,"xlsx");
    return blob;
}

export default fetchFile;
